import Module from './Module';
import * as log from 'loglevel';

/**
 * This module manages application state. You can set a state which triggers an event.
 * 
 * @extends Module
 * @category bootstrap
 * @author Geoffrey Mayeux
 */
class StateModule extends Module{
	constructor(bootstrap){
		super(bootstrap);

		this._previous = {};
		this._state    = {};
	}

	/**
	 * The previous state
	 * 
 	 * @type {Object}
	 */
	get previous(){ return this._previous; }

	/**
	 * The current state.
	 * When you set the state, the module triggers a 'state' event, passing the state as argument.
	 * 
 	 * @type {Object}
 	 * @fires StateModule#change
	 */
	get state(){ 	return this._state; }
	set state(state){
		log.debug('state', state);

		this._previous 	= this._state;
		this._state 	= state || {};
		
	    /**
	     * State change event.
	     *
	     * @event StateModule#change
	     * @type {object}
	     * @property {Object} state - The new state
	     */
		this.emit('change', this._state);
	}
}

export default StateModule;
export { StateModule };